import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters } from "./config";

const SpecialistList = () => {

  return (
    <Table tableId="specialists" title="Repair Specialist" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="full_name" idKey="specialist_id" fieldsToSearch={["Name", "Email", "Phone"]} />
  );
};

export default SpecialistList;